import { defineRouting } from 'next-intl/routing';
import { locales, defaultLocale } from './config';

export const routing = defineRouting({
  locales,
  defaultLocale,
  // Every URL carries its locale; `/` picks one from the NEXT_LOCALE cookie or Accept-Language (fallback: English)
  localePrefix: 'always',
});
